/**
 * Sidebar component following Tenant Nexus UI style guide
 */

import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/utils';

interface SidebarProps {
  className?: string;
}

const navigationItems = [
  {
    name: 'Dashboard',
    href: '/',
    icon: '📊',
    className: 'nav-dashboard',
  },
  {
    name: 'Tenant Management',
    href: '/tenants',
    icon: '🏢',
    className: 'nav-tenants',
  },
  {
    name: 'Workspace Management',
    href: '/workspaces',
    icon: '🏗️',
    className: 'nav-workspaces',
  },
  {
    name: 'User Management',
    href: '/users',
    icon: '👥',
    className: 'nav-users',
  },
  {
    name: 'Settings',
    href: '/settings',
    icon: '⚙️',
    className: 'nav-settings',
  },
  {
    name: 'Help & Support',
    href: '/support',
    icon: '🎧',
    className: 'nav-support',
  },
];

export function Sidebar({ className }: SidebarProps) {
  return (
    <nav className={cn('sidebar-panel', className)}>
      <div className="sidebar-header">
        <div className="sidebar-title">Management Actions</div>
        <div className="sidebar-subtitle">Streamline property management and customer relationships</div>
      </div>
      
      <div className="management-actions">
        <ul className="action-list">
          {navigationItems.map((item) => (
            <li key={item.name}>
              <NavLink
                to={item.href}
                className={({ isActive }) =>
                  cn(
                    'action-item',
                    isActive ? 'nav-active' : '',
                    item.className
                  )
                }
              >
                <div className="nav-icon">{item.icon}</div>
                {item.name}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
